/**
 * Portal Manta · Tokens de cor
 * Extraído de portal_manta_v28_12.jsx (linhas 145-162)
 * v29 modular · 2026-05-11
 */

export const M = {
  bg:         '#FFFFFF',  // bg principal
  bgAlt:      '#F9FAFB',  // bg alternado
  bgDark:     '#1A0F08',  // bg escuro (Pre)
  border:     '#E5E7EB',  // bordas tabela
  borderSoft: '#F3F4F6',  // separadores muito sutis
  text:       '#374151',  // texto body
  muted:      '#6B7280',  // labels secundários
  light:      '#9CA3AF',  // texto desabilitado
  heading:    '#5D3A1A',  // H1 marrom escuro
  title:      '#8B4A2D',  // H2 marrom quente
  accent:     '#E07B3D',  // laranja Manta (destaque)
  accentDark: '#C45A2B',  // terracota
  green:      '#10B981',  // status concluído
  red:        '#EF4444',  // status atrasado
  yellow:     '#D97706',  // status atenção
  blue:       '#2563EB',  // links / info
};

// Estados extras propostos (v29 · consolidação de cores hardcoded)
export const STATUS = {
  ok:        { bg: '#D1FAE5', fg: '#065F46', border: M.green },
  warn:      { bg: '#FEF3C7', fg: '#92400E', border: M.yellow },
  err:       { bg: '#FECACA', fg: '#991B1B', border: M.red },
  info:      { bg: '#DBEAFE', fg: '#1E40AF', border: M.blue },
  neutral:   { bg: '#F3F4F6', fg: '#374151', border: M.border },
};

export default M;
